import React from 'react';

const PersonIdContext = React.createContext();

export default PersonIdContext;
